<script setup lang="ts">
import comarkResolveComponent from "../../../common/app/utils/comark-components-manifest";
const { data: page } = await useApi(() => `/page?path=${useRoute().path}`)
if (!page.value) {
  throw createError({ statusCode: 404, fatal: true })
}

const platform = useState('platform')
</script>

<template>
  <UContainer>
    <UPage>
      <PlatformPageRender :page="page" :data="{platform: platform}"/>
    </UPage>
  </UContainer>
</template>